/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import styles from "./styles";
import { Text } from "@react-pdf/renderer";

const EastonGlovesPdfPage = (eastonData: any): any => {
  let htmlData: any = [];

  eastonData?.forEach((product: any) => {
    const productCustomizationJson = JSON.parse(product?.ProductCustomizationJson);

    htmlData = [
      ...htmlData,
      <Text key={product?.ConfigurationName} style={styles.productText}>
        {product?.ConfigurationName} (<Text style={styles.designIdColor}>{product?.DesignId}</Text>)
      </Text>,

      <Text key={product.SKU} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          SKU:
        </Text>{" "}
        {product.SKU}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Id:
        </Text>{" "}
        {product.DesignId}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Name:
        </Text>{" "}
        {product.ProductName}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Type:
        </Text>{" "}
        {product.DesignType}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Order Id:
        </Text>{" "}
        {productCustomizationJson?.OrderID}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Embroidery:
        </Text>
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Color:
        </Text>{" "}
        {productCustomizationJson?.embroidery["color"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Number Text:
        </Text>{" "}
        {productCustomizationJson?.embroidery["number-text"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Number Font:
        </Text>{" "}
        {productCustomizationJson?.embroidery["number-font"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Logo:
        </Text>{" "}
        {productCustomizationJson?.embroidery["logo"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Thumb Text:
        </Text>{" "}
        {productCustomizationJson?.embroidery["thumb-text"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Thumb Font:
        </Text>{" "}
        {productCustomizationJson?.embroidery["thumb-font"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Pinky Text:
        </Text>{" "}
        {productCustomizationJson?.embroidery["pinky-text"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Pinky Font:
        </Text>{" "}
        {productCustomizationJson?.embroidery["pinky-font"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Price With Currency:
        </Text>{" "}
        {productCustomizationJson?.PriceWithCurrency}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Sport:
        </Text>{" "}
        {productCustomizationJson?.sport}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Black Palm Color:
        </Text>{" "}
        {productCustomizationJson["back-palm-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Back Welting Color:
        </Text>{" "}
        {productCustomizationJson["back-welting-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Binding Color:
        </Text>{" "}
        {productCustomizationJson["binding-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Break In:
        </Text>{" "}
        {productCustomizationJson["break-in"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Template:
        </Text>{" "}
        {productCustomizationJson["design-template"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Finger And Web Laces Color:
        </Text>{" "}
        {productCustomizationJson["finger-and-web-laces-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Finger Hood:
        </Text>{" "}
        {productCustomizationJson["finger-hood"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Finger Pad:
        </Text>{" "}
        {productCustomizationJson["finger-pad"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Finger Pad or Hood Position:
        </Text>{" "}
        {productCustomizationJson["finger-pad-or-hood-position"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Fit Type:
        </Text>{" "}
        {productCustomizationJson["fit-type"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Hand Sewn:
        </Text>{" "}
        {productCustomizationJson["hand-sewn"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Hand Sewn Color:
        </Text>{" "}
        {productCustomizationJson["hand-sewn-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Heel Laces Color:
        </Text>{" "}
        {productCustomizationJson["heel-laces-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Heel Pad:
        </Text>{" "}
        {productCustomizationJson["heel-pad"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Index Finger Hood:
        </Text>{" "}
        {productCustomizationJson["index-finger-hood"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Index Finger Pad:
        </Text>{" "}
        {productCustomizationJson["index-finger-pad"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Lace Length:
        </Text>{" "}
        {productCustomizationJson["lace-length"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Leather:
        </Text>{" "}
        {productCustomizationJson["leather"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Lining Color:
        </Text>{" "}
        {productCustomizationJson["lining-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Logo Patch Color:
        </Text>{" "}
        {productCustomizationJson["logo-patch-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Mesh Style:
        </Text>{" "}
        {productCustomizationJson["mesh-style"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Middle Finger Hood:
        </Text>{" "}
        {productCustomizationJson["middle-finger-hood"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Middle Finger Pad:
        </Text>{" "}
        {productCustomizationJson["middle-finger-pad"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Palm Pad:
        </Text>{" "}
        {productCustomizationJson["palm-pad"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Palm Welting Color:
        </Text>{" "}
        {productCustomizationJson["palm-welting-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Position:
        </Text>{" "}
        {productCustomizationJson["position"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Shell Back:
        </Text>{" "}
        {productCustomizationJson["shell-back"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Shell Back Color:
        </Text>{" "}
        {productCustomizationJson["shell-back-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Shell Back Design:
        </Text>{" "}
        {productCustomizationJson["shell-back-design"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Shell Back Material:
        </Text>{" "}
        {productCustomizationJson["shell-back-material"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Shell Palm Color:
        </Text>{" "}
        {productCustomizationJson["shell-palm-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Size:
        </Text>{" "}
        {productCustomizationJson["size"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Stamping Color:
        </Text>{" "}
        {productCustomizationJson["stamping-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Thread Color:
        </Text>{" "}
        {productCustomizationJson["thread-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Throwing Hand:
        </Text>{" "}
        {productCustomizationJson["throwing-hand"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Trim Color:
        </Text>{" "}
        {productCustomizationJson["trim-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Trim Style:
        </Text>{" "}
        {productCustomizationJson["trim-style"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Web Color:
        </Text>{" "}
        {productCustomizationJson["web-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Web Style:
        </Text>{" "}
        {productCustomizationJson["web-style"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Welting Color:
        </Text>{" "}
        {productCustomizationJson["welting-color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Wrist Lining:
        </Text>{" "}
        {productCustomizationJson["wrist-lining"]}
      </Text>,
    ];
  });
  return htmlData;
};

export default EastonGlovesPdfPage;
